import { httpClient } from '@/infra/protocols/http';
import { IVoiceDTO } from '@/modules/voices/dtos/voice.dto';
import { IVoice } from '@/modules/voices/entities/voice.entity';
import { VoiceMapper } from '@/modules/voices/mappers/voice.mapper';

export async function associateVoices(
  params: AssociateVoicesService.Params,
  data: AssociateVoicesService.Payload,
): Promise<AssociateVoicesService.Response> {
  const response = await httpClient.put<IVoiceDTO[]>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/vozes`,
    data,
  );
  return response.map(VoiceMapper.toPresentation);
}

export namespace AssociateVoicesService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
  }

  export interface Payload {
    ids: number[];
  }

  export type Response = IVoice[];
}
